var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"400px"},attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"size":90,"width":"4","color":"primary","indeterminate":""}},[_c('v-progress-circular',{attrs:{"size":120,"width":"8","color":"primary","rotate":"30","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }